import Common from '../../../Common';

interface Body {
	text: string
}

const Log = class extends Common {
	create = (attemptId: id, data: Body) => this.post(`/callback/attempt/${attemptId}/log`, data)
}

export default Log
